import type {
  DispatchProps,
  OwnProps,
  StateProps,
} from 'components/common-form/sidePanel/priceEnhancer/PriceEnhancerRaw.connect';
import { PriceEnhancerWithNegotiationRaw } from 'components/common-form/sidePanel/priceEnhancer/PriceEnhancerWithNegotiation';
import { connect } from 'react-redux';
import * as addonSelector from 'state/addonForm/addonForm.selector';
import { formProductContainsAssetType } from 'state/common-form/commonForm.selectors';
import { quotePriceEnhancedThunk, quoteSponsoFeeThunk } from 'state/common-form/commonForm.thunks';
import { getUserPriceEnhancementByQuoteId, getUserSponsoFeesByQuoteId } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import { optionalMap } from 'utils/optional';

const multiplyBy100 = optionalMap<number>(x => x * 100);

const mapStateToProps = (state: AppState, { tabId, quoteId }: OwnProps): StateProps => {
  const remunerationMode = addonSelector.getRemunerationMode(state, tabId)!;
  const priceEnhancementMode = addonSelector.getPriceEnhancementMode(state, tabId, remunerationMode);
  const quoteResult = addonSelector.getQuoteResult(state, quoteId);
  const priceEnhancement = getUserPriceEnhancementByQuoteId(state, quoteId) ?? quoteResult!.priceEnhancement!;
  const sponsoFees = getUserSponsoFeesByQuoteId(state, quoteId);

  return {
    issuePrice: priceEnhancement.issuePrice! * 100,
    xMargin: priceEnhancement.xMargin! * 100,
    tradingOffer: priceEnhancement.tradingOffer! * 100,
    mode: priceEnhancementMode,
    sponso: multiplyBy100(sponsoFees?.sponso),
    sponsoUpFront: multiplyBy100(sponsoFees?.sponsoUpFront),
    topUpUpFront: multiplyBy100(sponsoFees?.topUpUpFront),
    yMarginRetrocession: multiplyBy100(sponsoFees?.yMarginRetrocession),
    displaySponsoFields: formProductContainsAssetType(state, tabId, 'postTrade', 'Rate'),
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId }: OwnProps): DispatchProps => ({
  onFieldValueChanged(field, value) {
    dispatch(quotePriceEnhancedThunk(tabId, 'postTrade', field, value));
  },
  onSponsoFeeFieldValueChanged(field, value) {
    dispatch(quoteSponsoFeeThunk(tabId, 'postTrade', field, value));
  },
});

export const ConnectedPriceEnhancerForPostTrade = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PriceEnhancerWithNegotiationRaw);
